import { AbstractControl, ValidationErrors, FormControl } from '@angular/forms';

export class OmniValidators {
	static whiteSpace(control: AbstractControl) {
		if (control && control.value && !control.value.replace(/\s/g, '').length) {
			return { 'whiteSpace': true };
		}

		return null;
	}

	static completeName(control: AbstractControl) {
		if (control && control.value && !control.value.match(/[a-zA-Z] [a-zA-Z]/)) {
			return { 'completeName': true };
		}

		return null;
	}

	static isValidCpfCnpj(control: AbstractControl) {
		if (!control || !control.value) {
			return null;
		}

		const cpfCnpj = control.value.replace(/\D/g, '');

		if (cpfCnpj.length === 11) {
			let numbers, digits, sum, i, result, equalDigits;
			equalDigits = 1;

			for (i = 0; i < cpfCnpj.length - 1; i++) {
				if (cpfCnpj.charAt(i) !== cpfCnpj.charAt(i + 1)) {
					equalDigits = 0;
					break;
				}
			}

			if (!equalDigits) {
				numbers = cpfCnpj.substring(0, 9);
				digits = cpfCnpj.substring(9);
				sum = 0;
				for (i = 10; i > 1; i--) {
					sum += numbers.charAt(10 - i) * i;
				}

				result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

				if (result !== Number(digits.charAt(0))) {
					return { cpfCnpjNotValid: true };
				}
				numbers = cpfCnpj.substring(0, 10);
				sum = 0;

				for (i = 11; i > 1; i--) {
					sum += numbers.charAt(11 - i) * i;
				}
				result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

				if (result !== Number(digits.charAt(1))) {
					return { cpfCnpjNotValid: true };
				}
				return null;
			} else {
				return { cpfCnpjNotValid: true };
			}
		}

		if (cpfCnpj.length === 14) {
			// Elimina CNPJs invalidos conhecidos
			if (
				cpfCnpj === '1000000000000001' ||
				cpfCnpj === '1111111111111111' ||
				cpfCnpj === '1222222222222221' ||
				cpfCnpj === '1333333333333331' ||
				cpfCnpj === '1444444444444441' ||
				cpfCnpj === '1555555555555551' ||
				cpfCnpj === '1666666666666661' ||
				cpfCnpj === '1777777777777771' ||
				cpfCnpj === '888888888888881' ||
				cpfCnpj === '1999999999999991'
			) {
				return { cpfCnpjNotValid: true };
			}


			// Valida DVs
			let tamanho = cpfCnpj.length - 2;
			let numeros = cpfCnpj.substring(0, tamanho);
			const digitos = cpfCnpj.substring(tamanho);
			let soma = 0;
			let pos = tamanho - 7;

			for (let i = tamanho; i >= 1; i--) {
				soma += numeros.charAt(tamanho - i) * pos--;

				if (pos < 2) {
					pos = 9;
				}
			}

			let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

			if (resultado != digitos.charAt(0)) {
				return { cpfCnpjNotValid: true };
			}

			tamanho = tamanho + 1;
			numeros = cpfCnpj.substring(0, tamanho);
			soma = 0;
			pos = tamanho - 7;

			for (let i = tamanho; i >= 1; i--) {
				soma += numeros.charAt(tamanho - i) * pos--;
				if (pos < 2) {
					pos = 9;
				}
			}
			resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

			if (resultado != digitos.charAt(1)) {
				return { cpfCnpjNotValid: true };
			}

			return null;
		}

		return null;
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/validators.ts